import { ParentProps } from "solid-js"
import style from './st-table.module.css'
import { Body } from "./fragments/Body";
import { Row } from "./fragments/Row";
import { Cell } from "./fragments/Cell";
import { SuperTitle } from "./fragments/SuperTitle";
import { Head } from "./fragments/Head";
import { HeadCell } from "./fragments/HeadCell";
import { TableContext, TableProvider } from "./TableContext";

const STTable = (props: ParentProps) => {
    const context = new TableContext();

    return (
        <TableProvider value={context}>
            <table class={style['st-table']} style={{
                'grid-template-columns': `repeat(${context.visibleColumnIds().length}, auto)`
            }}>
                {props.children}
            </table>
        </TableProvider>
    )
}

STTable.defaultProps = {};

STTable.Head = Head;
STTable.HeadCell = HeadCell;
STTable.Body = Body;
STTable.Row = Row;
STTable.Cell = Cell;
STTable.SuperTitle = SuperTitle;


export default STTable;
